var th_new_sidecart_remove_icon_svg='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="13px" height="13px"><path d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z"/></svg>'
var th_result_value;
var wc_th_pb_bb_shop_money= document.querySelector(".th_rebolt_custom_money_wc").dataset.th_rebolt_custom_money_wc;
var Shopify = Shopify || {}; Shopify.money_format = wc_th_pb_bb_shop_money, Shopify.formatMoney = function (a, e) { "string" == typeof a && (a = a.replace(".", "")); var o = "", r = /\{\{\s*(\w+)\s*\}\}/, t = e || this.money_format; function n(a, e) { return void 0 === a ? e : a } function i(a, e, o, r) { if (e = n(e, 2), o = n(o, ","), r = n(r, "."), isNaN(a) || null == a) return 0; var t = (a = (a / 100).toFixed(e)).split("."); return t[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (t[1] ? r + t[1] : "") } switch (t.match(r)[1]) { case "amount": o = i(a, 2); break; case "amount_no_decimals": o = i(a, 0); break; case "amount_with_comma_separator": o = i(a, 2, ".", ","); break; case "amount_no_decimals_with_comma_separator": o = i(a, 0, ".", ",") }return t.replace(r, o) };
let th_returns_format_money = (final) => { return Shopify.formatMoney(final, wc_th_pb_bb_shop_money) }
let th_bb_product_data=[];

let th_selected_section_index=()=>{
  let th_current_selected_section=0;
  let th_list_of_sections=document.querySelectorAll('.th_pb_cb_ms_steps')
  th_list_of_sections.forEach((section,section_index)=>{
      if(section.classList.contains('th_pb_cb_ms_steps_activated')){
          th_current_selected_section=section_index;
      }
  })
  return th_current_selected_section;
}

let th_add_compare_at_price_to_sidecart=($wcpb_bb_api_json)=>{
  if(th_result_value && th_result_value.data.use_fixed_price==1){
    let th_total_compare_price=0;
    let th_sidecart_product=document.querySelectorAll('.th_pb_cb_sidecart_p_grid_section');
    let sidecart_compare_at_price_element=document.querySelector('.th_pb_cb_sidecart_inner .th_pb_cb_sidecart_title .th_pb_line_through');
    let th_bb_fixed_dicscount_compare_price=document.querySelector('.th_bb_fixed_dicscount_compare_price')
    th_sidecart_product.forEach((sidecart_product)=>{
      let th_section_index=sidecart_product.querySelector('.th_pb_cb_sidecart_p_grid_remove_product').dataset.section;
      let th_product_grid_index=sidecart_product.querySelector('.th_pb_cb_sidecart_p_grid_remove_product').dataset.grd_pro_indx;
      let th_product_variant_id=sidecart_product.querySelector('.th_pb_cb_sidecart_p_grid_image_figure img').dataset.variant_id;
      let th_pb_cb_sidecart_p_grid_qty=parseFloat(sidecart_product.querySelector('.th_pb_cb_sidecart_p_grid_qty').innerText);

      let th_product_json_object=th_bb_product_data[th_section_index][th_product_grid_index];
      let th_product_json_object_selected_variant=th_product_json_object.variants.filter((filter_variant)=>th_product_variant_id==filter_variant.id);
      th_total_compare_price+=parseFloat(th_product_json_object_selected_variant[0].price*th_pb_cb_sidecart_p_grid_qty)
    })

    if(sidecart_compare_at_price_element){
      sidecart_compare_at_price_element.innerHTML=`<span class='th_bb_fixed_dicscount_compare_price'>${th_returns_format_money(th_total_compare_price*100)}</span>`
    }else if(th_bb_fixed_dicscount_compare_price){
      th_bb_fixed_dicscount_compare_price.innerText=th_returns_format_money(th_total_compare_price*100)
    }else{
      let th_sidecart_total_sell_price=document.querySelector('.th_pb_cb_sidecart_inner .th_pb_cb_sidecart_title .th_pb_main_price');
      th_sidecart_total_sell_price.insertAdjacentHTML('afterend',`<span class='th_bb_fixed_dicscount_compare_price'>${th_returns_format_money(th_total_compare_price*100)}</span>`)
    }
    if(th_total_compare_price==0){
      if(sidecart_compare_at_price_element){sidecart_compare_at_price_element.remove()}
      if(th_bb_fixed_dicscount_compare_price){th_bb_fixed_dicscount_compare_price.remove()}
    }
  }
}

let th_add_compare_at_price_to_sidecart_for_short_buildbox=($wcpb_bb_api_json)=>{
  let sidecart_compare_at_price_element=document.querySelector('.th_pb_cb_sidecart_inner .th_pb_cb_sidecart_title .th_pb_line_through');
  let th_bb_fixed_dicscount_compare_price=document.querySelector('.th_bb_fixed_dicscount_compare_price');
  
  if($wcpb_bb_api_json.use_fixed_price==1){
    let th_total_compare_price=0;
    if($wcpb_bb_api_json.bundle_structure_type==0 && $wcpb_bb_api_json.wcpb_bb_single_section.length>0){
      $wcpb_bb_api_json.wcpb_bb_single_section.forEach((sidecart_add_product)=>{
        let added_qty=sidecart_add_product.added_qty;
        let v_price=sidecart_add_product.v_price;
        th_total_compare_price+=(added_qty*v_price);
      })
    }else if($wcpb_bb_api_json.bundle_structure_type==1){
      $wcpb_bb_api_json.wcpb_bb_multi_section.forEach((section)=>{
        if(section.added_products.length>0){
            section.added_products.forEach((sidecart_add_product)=>{
              let added_qty=sidecart_add_product.added_qty;
              let v_price=sidecart_add_product.v_price;
              th_total_compare_price+=(added_qty*v_price);
            })
        }
      })
    }
   
    if(th_total_compare_price>0){
       if(sidecart_compare_at_price_element){
        sidecart_compare_at_price_element.innerHTML=`<span class='th_bb_fixed_dicscount_compare_price'>${th_returns_format_money(th_total_compare_price*100)}</span>`;
       }else if(th_bb_fixed_dicscount_compare_price){
         th_bb_fixed_dicscount_compare_price.innerText=th_returns_format_money(th_total_compare_price*100)
       }else{
        let th_sidecart_total_sell_price=document.querySelector('.th_pb_cb_sidecart_inner .th_pb_cb_sidecart_title .th_pb_main_price');
        th_sidecart_total_sell_price.insertAdjacentHTML('afterend',`<span class='th_bb_fixed_dicscount_compare_price'>${th_returns_format_money(th_total_compare_price*100)}</span>`);
       }
    }
    if(th_total_compare_price==0){
      if(sidecart_compare_at_price_element){sidecart_compare_at_price_element.remove()}
      if(th_bb_fixed_dicscount_compare_price){th_bb_fixed_dicscount_compare_price.remove()}
    }
  }
}
let th_add_sidecart_product_remove_icon=()=>{
  let th_sidecart_remove_icons=document.querySelectorAll(".th_pb_cb_sidecart_p_grid_remove_product")
  th_sidecart_remove_icons.forEach((th_sidecart_remove_icon)=>{
    th_sidecart_remove_icon.innerHTML=th_new_sidecart_remove_icon_svg;
  })
}

let th_add_eventLitener_to_sidecart_remove_btn=()=>{
    let th_pb_cb_sidecart_p_grid_remove_product_btns=document.querySelectorAll('.th_pb_cb_sidecart_p_grid_remove_product');
    th_pb_cb_sidecart_p_grid_remove_product_btns.forEach((th_sidecart_remove_btn)=>{
    th_sidecart_remove_btn.addEventListener('click',()=>{
     th_add_compare_at_price_to_sidecart();
    })
  })
}
let th_add_event_listeners=()=>{
  let th_product_grid_first_addtocart_btns=document.querySelectorAll('.th_pb_cb_p_grid_add_btn');
  let th_pb_cb_p_grid_add_qty_plus_btn=document.querySelectorAll('.th_pb_cb_p_grid_add_qty_plus');
  let th_pb_cb_p_grid_add_qty_minus_btns=document.querySelectorAll('.th_pb_cb_p_grid_add_qty_minus');
  
    th_product_grid_first_addtocart_btns.forEach((th_bb_pr_first_add_btn)=>{
      th_bb_pr_first_add_btn.addEventListener('click',()=>{
        th_add_sidecart_product_remove_icon();
        th_add_eventLitener_to_sidecart_remove_btn();
        th_add_compare_at_price_to_sidecart();
      })
    })

   th_pb_cb_p_grid_add_qty_plus_btn.forEach((th_plus_btn)=>{
     th_plus_btn.addEventListener('click',()=>{
        th_add_sidecart_product_remove_icon();
        th_add_eventLitener_to_sidecart_remove_btn();
        th_add_compare_at_price_to_sidecart();
     })
   })

  th_pb_cb_p_grid_add_qty_minus_btns.forEach((th_minus_btn)=>{
    th_minus_btn.addEventListener('click',()=>{
      th_add_compare_at_price_to_sidecart();
    })
  })
}

let wc_bb_single_available=(result_value)=>{
    th_result_value=result_value;
    if(th_bb_product_data[th_selected_section_index()]==undefined){th_bb_product_data[th_selected_section_index()]=[];}
    if(result_value.data.bundle_structure_type==1){
      th_bb_product_data[th_selected_section_index()].push(...result_value.data.sections[0].products);
    }else{
      th_bb_product_data[th_selected_section_index()].push(...result_value.data.products);
    }
    let th_search_element=document.querySelector('.wc_search_box_option')
    if(th_search_element){
    th_search_element.insertAdjacentHTML('afterend',`<div class='th_search_icon'><svg xmlns="http://www.w3.org/2000/svg" viewBox="50 50" width="45" height="43">    <path d="M 7 4 C 5.35 4 4 5.35 4 7 L 4 43 C 4 44.65 5.35 46 7 46 L 43 46 C 44.65 46 46 44.65 46 43 L 46 7 C 46 5.35 44.65 4 43 4 L 7 4 z M 22.5 13 C 27.74 13 32 17.26 32 22.5 C 32 24.76 31.210625 26.840703 29.890625 28.470703 L 37.710938 36.289062 L 36.289062 37.710938 L 28.470703 29.890625 C 26.840703 31.210625 24.76 32 22.5 32 C 17.26 32 13 27.74 13 22.5 C 13 17.26 17.26 13 22.5 13 z M 22.5 15 A 7.5 7.5 0 0 0 15 22.5 A 7.5 7.5 0 0 0 22.5 30 A 7.5 7.5 0 0 0 30 22.5 A 7.5 7.5 0 0 0 22.5 15 z"/></svg></div>`)
    }
    th_add_event_listeners();
}
let th_bb_section_change_without_API_call=()=>{
    th_add_event_listeners();
}
let wc_bb_single_available_other_products=(other_product_result)=>{
   if(th_bb_product_data[th_selected_section_index()]==undefined){th_bb_product_data[th_selected_section_index()]=[];}
   if(th_result_value.data.bundle_structure_type==1){
      th_bb_product_data[th_selected_section_index()].push(...other_product_result.data.sections[0].products);
   }else{
     th_bb_product_data[th_selected_section_index()].push(...other_product_result.data[0].products);
   }
   th_add_event_listeners();
}
window.$search_items_updated=()=>{
   th_add_event_listeners();
}
window.$th_search_results_back=()=>{
   th_add_event_listeners();
}



window.$wcpb_bb_custom_callback_event=($wcpb_bb_api_json)=>{
    th_add_sidecart_product_remove_icon();
    th_add_compare_at_price_to_sidecart_for_short_buildbox($wcpb_bb_api_json);
}